import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import * as _ from 'lodash';
import { ColorSample } from './ColorSample/ColorSample';
import styles from './ColorSampleGroup.scss';
import classNames from 'classnames';
export let DataHook = /*#__PURE__*/function (DataHook) {
  DataHook["colorGroup"] = "colorGroup";
  return DataHook;
}({});
export class ColorSampleGroup extends React.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    _defineProperty(this, "onSelect", option => {
      let selected;
      const {
        allowMultiple,
        selected: prevSelected
      } = this.props;
      if (allowMultiple || this.isSelected(option)) {
        if (this.isSelected(option)) {
          selected = prevSelected.filter(s => s.id !== option.id);
        } else {
          selected = [...prevSelected, option];
        }
      } else {
        selected = [option];
      }
      if (this.props.onSelect) {
        this.props.onSelect(selected);
      }
    });
    _defineProperty(this, "onKeyboardArrowEvent", function (direction, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      const {
        options,
        isRTL
      } = _this.props;
      const {
        currentFocus
      } = _this.state;
      const directionWithRTL = direction * (isRTL ? -1 : 1);
      let nextFocus = currentFocus + directionWithRTL + offset;
      if (nextFocus >= options.length) {
        nextFocus = 0;
      }
      if (nextFocus === -1) {
        nextFocus = options.length - 1;
      }
      if (options[nextFocus].isDisabled) {
        return _this.onKeyboardArrowEvent(direction, offset + directionWithRTL);
      }
      _this.setState({
        currentFocus: nextFocus
      });
    });
    _defineProperty(this, "onKeyboardTabEvent", () => {
      this.setState({
        currentFocus: 0
      });
    });
    _defineProperty(this, "isOptionVisible", option => {
      return option.isVisible !== false;
    });
    this.state = {
      currentFocus: 0
    };
  }
  render() {
    var _this$props$selected;
    const {
      options,
      onMouseEnter,
      onMouseLeave,
      colorSampleClassName,
      shouldFocus,
      colorGroupClassName,
      allowMultiple
    } = this.props;
    const {
      currentFocus
    } = this.state;
    const colorGroupClasses = classNames([styles.colorSampleList, colorGroupClassName]);
    const isAnyColorSelected = !!((_this$props$selected = this.props.selected) != null && _this$props$selected.length);
    return /*#__PURE__*/React.createElement("ul", {
      className: colorGroupClasses,
      "data-hook": DataHook.colorGroup
    }, options.filter(this.isOptionVisible).map((option, i) => {
      return /*#__PURE__*/React.createElement("li", {
        key: `color-${i}`
      }, /*#__PURE__*/React.createElement(ColorSample, {
        description: option.description,
        isDisabled: option.isDisabled,
        isFocused: currentFocus === i,
        isSelected: this.isSelected(option),
        onChange: () => this.onSelect(option),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: () => this.setState({
          currentFocus: i
        }),
        onKeyboardArrowEvent: this.onKeyboardArrowEvent,
        onKeyboardTabEvent: this.onKeyboardTabEvent,
        rgbColorValue: option.value,
        image: option.image,
        colorSampleClassName: colorSampleClassName,
        shouldFocus: shouldFocus,
        allowMultiple: allowMultiple,
        isAnyColorSelected: isAnyColorSelected
      }));
    }));
  }
  isSelected(option) {
    return _.some(this.props.selected, s => s.id === option.id);
  }
}
_defineProperty(ColorSampleGroup, "defaultProps", {
  allowMultiple: false,
  isRTL: false,
  shouldFocus: true
});
//# sourceMappingURL=ColorSampleGroup.js.map